import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App.tsx";
import "./config/init-i18n.ts";
import { config } from "./config/config.ts";
import axios from "axios";

Sentry.init({
  dsn: config.SENTRY_DSN,
  environment: config.ENVIRONMENT,
  beforeSend(event, hint) {
    const error = hint.originalException;

    if (axios.isAxiosError(error) && error.response?.status === 401) {
      return null;
    }

    return event;
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
